module.exports = __webpack_public_path__ + "img/university-logo-small.1d3dcc4f.svg";